import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

import { authAtom } from "stores";
import { useRecoilState } from "recoil";

import { onUpdateCompanyRes } from "./helper";
import { urlMaker } from "utils";

export const useUpdateCompany = () => {
  const [auth, setAuth] = useRecoilState(authAtom);

  return useMutation({
    mutationKey: [Keys.UPDATE_COMPANY],
    mutationFn: (data: CompanyReqT) =>
      axios({
        method: "post",
        url: urlMaker(Routes.UPDATE_COMPANY, auth.company.id) + "?_method=put",
        data,
        headers: { "Content-Type": "multipart/form-data" },
      }),
    onSuccess: (res) =>
      onUpdateCompanyRes({ company: res.data?.data, setAuth }),
  });
};
